// extracted by mini-css-extract-plugin
export default {"modal":"modalComponent_modal__cqLPr","modalHeader":"modalComponent_modalHeader__wmpuA","modalBody":"modalComponent_modalBody__p6Ivj"};